export default __webpack_public_path__ + "static/media/browser-stats.8e3eab55.png";